module.exports = __webpack_public_path__ + "static/media/cross-icon.d4b2fdb5.svg";